import { collection, deleteDoc, doc, getDocs, setDoc } from 'firebase/firestore';
import { firestore } from '@api/Firebase/Firebase';
import {
    NOTIFICATION_TEMPLATES_COLLECTION,
    NotificationTemplateOverride,
    NotificationTemplateOverrides
} from '@api/NotificationTemplates/NotificationTemplates';

/**
 * Overrides de las plantillas internas — lado ADMIN.
 *
 * Lee la colección completa (≤16 docs) con **caché de 60 s** y NUNCA lanza:
 * los emisores de la campana (tablero, caja, retrasos) no pueden quedarse
 * mudos porque la capa de configuración falle — sin overrides se emite con
 * los textos del catálogo, que viven en el código.
 *
 * La ESCRITURA (guardar/restaurar) es de la pantalla de administración y sí
 * lanza: quien edita necesita enterarse si su cambio no se guardó.
 */

const templatesRef = collection(firestore, NOTIFICATION_TEMPLATES_COLLECTION);
const CACHE_MS = 60_000;
let cache: { at: number; overrides: NotificationTemplateOverrides } | undefined;

export default {
    async getOverrides(): Promise<NotificationTemplateOverrides> {
        if (cache && Date.now() - cache.at < CACHE_MS) return cache.overrides;
        try {
            const snapshot = await getDocs(templatesRef);
            const overrides: NotificationTemplateOverrides = {};
            snapshot.docs.forEach((document) => {
                overrides[document.id] = document.data() as NotificationTemplateOverride;
            });
            cache = { at: Date.now(), overrides };
            return overrides;
        } catch (error) {
            console.error('No se pudieron leer las plantillas internas:', error);
            return cache?.overrides || {};
        }
    },

    /** Guarda el override de UNA plantilla y refresca la caché local. */
    async saveOverride(key: string, override: { title?: string; body?: string }): Promise<void> {
        await setDoc(doc(templatesRef, key), { ...override, updatedAt: Date.now() });
        cache = undefined;
    },

    /** Restaurar el texto original = borrar el override. */
    async restoreDefault(key: string): Promise<void> {
        await deleteDoc(doc(templatesRef, key));
        cache = undefined;
    }
};
